import * as React from "react";
import TopCategories from "./TopCategories";
import Banner from "./Banner";
import FeaturedProducts from "./FeaturedProduct";


function MainContent() {
  return (
    <div className="main-content" >
      <Banner/>
      <TopCategories />
      <FeaturedProducts/>
      
    </div>
  );
}
export default MainContent;
